// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-shypcx-index-main_right_content-3H3QZ","table":"components-tjcx-shypcx-index-table-2-JI9"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/shypcx/index.css
// module id = 1927
// module chunks = 0